<template>
  <button class="text-sm block rounded w-full px-3 py-1.5 font-bold text-center cursor-pointer" :style="{ backgroundColor: team?.theme?.base, color: team?.theme?.text, borderColor: useHexToRgba(team?.theme?.base, 1) }" @click="user.toggleFavorite(team)">
    {{ $t('shared.follow') }}
  </button>
</template>

<script setup>
const user = useUserStore()
const team = useTeamStore()
</script>
